import { z } from 'zod';
/**
 * The 5-connector menu (epics #7 + #8). Adding a connector kind here
 * is the first step; the registry in `apps/functions/src/connectors/registry.ts`
 * then needs an implementation that satisfies `ConnectorAdapter`.
 *
 * Mapping to `GraphSourceTool` (the broader vocabulary the graph node
 * `source` field uses) is NOT 1:1 — Gmail emits nodes with
 * `source: 'email'` because the graph treats Gmail/Outlook/IMAP as one
 * source-tool family. The other four kinds map directly:
 *   slack       → 'slack'
 *   gmail       → 'email'
 *   salesforce  → 'salesforce'
 *   github      → 'github'
 *   stripe      → 'stripe'
 */
export const CONNECTOR_KINDS = [
    'slack',
    'gmail',
    'salesforce',
    'github',
    'stripe',
];
export const ConnectorKind = z.enum(CONNECTOR_KINDS);
/**
 * Install scope — whether the OAuth/install dance is workspace-wide
 * (admin connects once for the whole org) or per-user (each member
 * connects their own inbox). Slack/Salesforce/Stripe/GitHub-App are
 * workspace; Gmail is per-user.
 */
export const CONNECTOR_INSTALL_SCOPES = ['workspace', 'per-user'];
export const ConnectorInstallScope = z.enum(CONNECTOR_INSTALL_SCOPES);
/** Per-kind default install scope. Drives the admin UI's connect flow. */
export const CONNECTOR_INSTALL_SCOPE_DEFAULTS = {
    slack: 'workspace',
    gmail: 'per-user',
    salesforce: 'workspace',
    github: 'workspace',
    stripe: 'workspace',
};
